import {
  ASSIST_MIGRATION_DEFAULT_BUSINESS_SETTINGS,
  ASSIST_MIGRATION_DEFAULT_FLAG_KEYS,
} from 'constants/assist/assistMigration';
import type { GetAssistMigrationColumnVisibilityModel } from 'types/assist/getAssistMigrationColumnVisibilityModel';

export const getAssistMigrationColumnVisibilityModel: GetAssistMigrationColumnVisibilityModel = ({
  currentVisibilityModel,
  businessSettingsKeys,
  featureFlagKeys,
}) => {
  const hiddenBusinessSettingFields = businessSettingsKeys
    .filter((key) => !ASSIST_MIGRATION_DEFAULT_BUSINESS_SETTINGS.includes(key))
    .map((key) => `bs_${key}`);
  const hiddenFeatureFlagFields = featureFlagKeys
    .filter((key) => !ASSIST_MIGRATION_DEFAULT_FLAG_KEYS.includes(key))
    .map((key) => `ff_${key}`);
  const newlyDiscoveredFields = [...hiddenBusinessSettingFields, ...hiddenFeatureFlagFields].filter(
    (field) => currentVisibilityModel[field] === undefined,
  );

  if (!newlyDiscoveredFields.length) {
    return currentVisibilityModel;
  }

  return {
    ...currentVisibilityModel,
    ...Object.fromEntries(newlyDiscoveredFields.map((field) => [field, false])),
  };
};
